import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'src/types/rootState'

export interface Navbar {
  mobileNavIsOpen: boolean
  listItemLoading: boolean
  clickedListItem: string
}

const initialState: Navbar = {
  mobileNavIsOpen: false,
  listItemLoading: false,
  clickedListItem: '',
}

const navbarSlice = createSlice({
  name: 'navbar',
  initialState,
  reducers: {
    setMobileNavIsOpen: (state, action: PayloadAction<boolean>) => {
      state.mobileNavIsOpen = action.payload
    },
    setListItemLoading: (state, action: PayloadAction<boolean>) => {
      state.listItemLoading = action.payload
    },
    setClickedListItem: (state, action: PayloadAction<string>) => {
      state.clickedListItem = action.payload
    },
  },
})

export const selectMobileNavIsOpen = (state: RootState) =>
  state.navbar.mobileNavIsOpen

export const selectListItemLoading = (state: RootState) =>
  state.navbar.listItemLoading

export const selectClickedListItem = (state: RootState) =>
  state.navbar.clickedListItem

export const { setMobileNavIsOpen, setListItemLoading, setClickedListItem } =
  navbarSlice.actions

export default navbarSlice.reducer
